import { object, string, number } from 'yup';

const accountingLineItemSchema = object({
  amount: number().moreThan(0, 'amount must be more than $0').required(),
  description: string().required(),
  changelog: string().required('please provide a note about the change'),
});

export default accountingLineItemSchema;
